import { ReportColumn } from 'types';
import { useReportColumns } from '../../../../hooks';

export const useRespondedOnTimeColumns = (): ReportColumn[] => {
  const {
    consultationType,
    applicationReference,
    authority,
    category,
    consultationRequestDate,
    consulteeResponseDueDate,
    dateConsultationRespondedTo,
    responseType,
  } = useReportColumns();

  return [
    consultationType,
    applicationReference,
    authority,
    category,
    consultationRequestDate,
    consulteeResponseDueDate,
    dateConsultationRespondedTo,
    responseType,
  ];
};
